//  export const API=process.env.REACT_APP_BACKEND_LOCAL
// export const APIMEDIA=process.env.REACT_APP_BACKEND_LOCAL_MEDIA

export const API=process.env.REACT_APP_BACKEND_DIGITALOCEAN_NEWNAME
 export const APIMEDIA=process.env.REACT_APP_BACKEND_DIGITALOCEAN_MEDIA_NEWNAME



